<template>
    <modal @close="cancelClick" class="edit-modal" hideFooter id="edit-fleet-info">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Fleet Information</h3>
                    <p>
                        Use this form to update your trucking fleet's details.
                    </p>
                    <ul>
                        <li>Number of trucks in your fleet</li>
                        <li>International Fuel Tax Agreement (IFTA) license number</li>
                        <li>U.S. Department of Transportation (DOT) number</li>
                    </ul>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Fleet Information</h3>
                    <div class="md-col-2">
                        <div class="column">
                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Fleet Size:</label>
                                <input class="td-input" v-model="update.fleetSize" type="number" placeholder="Fleet Size" />
                            </div>

                            <div class="my-1">
                                <label class="td-label td-text-bold">IFTA Number:</label>
                                <input class="td-input" v-model="update.iftaNumber" type="text" placeholder="IFTA Number" />
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">DOT Number:</label>
                                <input class="td-input" v-model="update.dotNumber" type="text" placeholder="DOT Number" />
                            </div>
                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="cancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="saveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditFleetInfo';
    export default script;
</script>
<style lang="less">
    @import './EditFleetInfo.less';
</style>